import { render, staticRenderFns } from "./PopupAcademicLevel.vue?vue&type=template&id=64f68f8c"
import script from "./PopupAcademicLevel.vue?vue&type=script&lang=js"
export * from "./PopupAcademicLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports